import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c57154b8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57154b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c57154b8')) {
      api.createRecord('c57154b8', component.options)
    } else {
      api.reload('c57154b8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c57154b8&scoped=true", function () {
      api.rerender('c57154b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/index.vue"
export default component.exports